module.exports = __webpack_public_path__ + "img/hr-V-R-4-load-connect-shadow.2fd9be45.png";